/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

const ChangeTemp = (props) => {
  const { data } = props;

  return (
    <div className="change-temp">
      <input
        type="radio"
        id="radio2"
        name="radios"
        checked={data.degree === 'I'}
        onChange={() => {
          data.func(data.temperature.temp * 1.8 + 32, 'I');
        }}
      />
      <label htmlFor="radio2">°F</label>
      <input
        type="radio"
        id="radio3"
        name="radios"
        checked={data.degree === 'M'}
        onChange={() => {
          data.func(data.temperature.temp, 'M');
        }}
      />
      <label htmlFor="radio3">°С</label>
    </div>
  );
};

export default ChangeTemp;
